/* globals: wc_bookings_admin_calendar_js_params */

/**
 * External dependencies
 */
import { render } from '@wordpress/element';
import { forEach } from 'lodash';

/**
 * Internal dependencies.
 */
import DatePickerPopoverMonth from './components/datepicker-popover-month';
import DatePickerPopoverDay from './components/datepicker-popover-day';
import CalendarPopover from './components/calendar-popover';

const { default_month, default_year, default_day } = wc_bookings_admin_calendar_js_params;

const popoverContainerMonth = document.getElementById( 'wc-bookings-datepicker-container-month' );

if ( null !== popoverContainerMonth ) {
	const pickerMonth = <DatePickerPopoverMonth year={ default_year } month={ default_month } />;
	render( pickerMonth, popoverContainerMonth );
}

const popoverContainerDay = document.getElementById( 'wc-bookings-datepicker-container-day' );

if ( null !== popoverContainerDay ) {
	const pickerDay = <DatePickerPopoverDay year={ default_year } month={ default_month } day={ default_day } />;
	render( pickerDay, popoverContainerDay );
}

const calendarEventMonth = document.getElementsByClassName( 'calendar_month_event' );

if ( null !== calendarEventMonth ) {
	forEach( calendarEventMonth, function( value, key ) {
		render( <CalendarPopover element={ value } position={ 'bottom center' } />, value );
	} );
}

const calendarEventDay = document.getElementsByClassName( 'daily_view_booking' );

if ( null !== calendarEventDay ) {
	forEach( calendarEventDay, function( value, key ) {
		render( <CalendarPopover element={ value } position={ 'bottom center' } />, value.childNodes[0] );
	} );
}
